import { aboutContent } from '@/mocks/homepage';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full aspect-[3/2] rounded-2xl overflow-hidden bg-background-200">
              <img
                src={aboutContent.img}
                alt={aboutContent.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
              {aboutContent.title}
            </h2>
            <div className="space-y-4">
              {aboutContent.paragraphs.map((para, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-5 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                每周 50+ 原创推荐
              </span>
              <span className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                覆盖 30,000+ 部作品
              </span>
              <span className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                7×24 小时更新追踪
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}